export const isEmptyObject = (obj) => (obj !== undefined ? Object.keys(obj).length === 0 : true);
